/* Progressive header controller; one lifecycle per header, including Theme Editor reloads. */
(() => {
  if (window.AZEditorialHeader) { window.AZEditorialHeader.init(); return; }
  const instances = new WeakMap();
  function mount(header) {
    if (instances.has(header)) return;
    const lifecycle = new AbortController(), options = { signal:lifecycle.signal };
    const on = (el,event,fn) => el?.addEventListener(event,fn,options);
    const find = selector => header.querySelector(selector);
    const all = selector => [...header.querySelectorAll(selector)];
    const desktop = matchMedia('(min-width:990px)'), fine = matchMedia('(hover:hover) and (pointer:fine)');
    const mega=find('[data-sf-mega]'), nav=find('.sf-header__desktop-menu');
    const panels=all('[data-sf-mega-panel]'), triggers=all('[data-sf-desktop-trigger]');
    const drawer=find('[data-sf-mobile-drawer]'), opener=find('[data-sf-mobile-open]');
    const pages=all('[data-sf-mobile-page]');
    const search=find('[data-sf-header-search]'), searchOpener=find('[data-sf-header-search-open]');
    let active=null, openTimer=0, closeTimer=0, returning=false, mobileReturn=null;
    let modal=null, modalOpener=null, background=[];
    const focusable = el => [...el.querySelectorAll('a[href],button,input,summary,[tabindex="0"]')].filter(x=>!x.disabled&&!x.closest('[inert]')&&x.getClientRects().length&&getComputedStyle(x).visibility!=='hidden');
    function restoreFocus(el) { returning=true;el?.focus();queueMicrotask(()=>{returning=false;}); }
    function closeMega(focus=false) {
      clearTimeout(openTimer);clearTimeout(closeTimer);
      const previous=triggers.find(t=>t.dataset.sfDesktopTrigger===active);
      active=null;mega?.classList.remove('is-open');header.classList.remove('has-mega');
      panels.forEach(p=>{p.classList.remove('is-active');p.inert=true;});
      triggers.forEach(t=>t.classList.remove('is-active'));
      all('[data-sf-desktop-toggle]').forEach(b=>b.setAttribute('aria-expanded','false'));
      if(focus)restoreFocus(previous);
    }
    function openMega(index) {
      clearTimeout(openTimer);clearTimeout(closeTimer);
      const panel=panels.find(p=>p.dataset.sfMegaPanel===String(index));
      if(!desktop.matches||!panel||modal){closeMega();return;}
      active=String(index);panels.forEach(p=>{const selected=p===panel;p.inert=!selected;p.classList.toggle('is-active',selected);});
      triggers.forEach(t=>t.classList.toggle('is-active',t.dataset.sfDesktopTrigger===active));
      all('[data-sf-desktop-toggle]').forEach(b=>b.setAttribute('aria-expanded',String(b.dataset.sfDesktopToggle===active)));
      mega.classList.add('is-open');header.classList.add('has-mega');
    }
    all('[data-sf-desktop-item]').forEach(item=>{
      on(item,'pointerenter',()=>{if(!fine.matches)return;clearTimeout(closeTimer);clearTimeout(openTimer);openTimer=setTimeout(()=>openMega(item.dataset.sfDesktopItem),120);});
      on(item,'pointerleave',()=>clearTimeout(openTimer));
    });
    triggers.forEach(trigger=>{
      on(trigger,'focus',()=>{if(!returning)openMega(trigger.dataset.sfDesktopTrigger);});
      on(trigger,'click',event=>{if(trigger.getAttribute('href')==='#'){event.preventDefault();openMega(trigger.dataset.sfDesktopTrigger);}});
    });
    all('[data-sf-desktop-toggle]').forEach(toggle=>on(toggle,'click',()=>{const index=toggle.dataset.sfDesktopToggle;active===index?closeMega():openMega(index);}));
    on(nav,'keydown',event=>{
      if(event.key==='ArrowDown'&&event.target.closest('.az-menu-trigger')){
        const item=event.target.closest('[data-sf-desktop-item]');openMega(item.dataset.sfDesktopItem);
        const p=panels.find(p=>!p.inert);if(p){event.preventDefault();focusable(p)[0]?.focus();}
      }
    });
    on(nav,'pointerenter',()=>clearTimeout(closeTimer));
    on(nav,'pointerleave',()=>{clearTimeout(openTimer);closeTimer=setTimeout(()=>{if(!nav.contains(document.activeElement))closeMega();},220);});
    on(nav,'focusout',()=>queueMicrotask(()=>{if(!nav.contains(document.activeElement))closeMega();}));
    on(find('[data-sf-mega-close]'),'click',()=>closeMega());
    on(document,'click',event=>{if(!header.contains(event.target))closeMega();});
    function lockBackground() {
      background=[...document.body.children].filter(el=>!el.contains(header)&&!['SCRIPT','STYLE','LINK'].includes(el.tagName)).map(el=>[el,el.inert]);
      background.forEach(([el])=>{el.inert=true;});
    }
    function unlockBackground(){background.forEach(([el,was])=>{el.inert=was;});background=[];}
    function showPage(name,focus=true) {
      const next=pages.find(p=>p.dataset.sfMobilePage===name);if(!next)return;
      pages.forEach(p=>{p.inert=p!==next;p.classList.toggle('is-active',p===next);});
      next.scrollTop=0;
      if(focus)(next.querySelector('[data-sf-mobile-back]')||focusable(next)[0])?.focus();
    }
    function closeModal(restore=true) {
      const prior=modalOpener;
      if(modal){modal.classList.remove('is-open');modal.setAttribute('aria-hidden','true');modal.inert=true;}
      opener?.setAttribute('aria-expanded','false');searchOpener?.setAttribute('aria-expanded','false');
      document.body.classList.remove('sf-mobile-menu-open','sf-header-search-open');
      modal=null;modalOpener=null;unlockBackground();if(restore)restoreFocus(prior);
    }
    function openModal(target,button) {
      if(!target)return;closeMega();closeModal(false);modal=target;modalOpener=button;
      target.inert=false;target.classList.add('is-open');target.setAttribute('aria-hidden','false');button?.setAttribute('aria-expanded','true');
      document.body.classList.add(target===drawer?'sf-mobile-menu-open':'sf-header-search-open');lockBackground();
      if(target===drawer)showPage('main',false);
      (target===search?target.querySelector('[data-predictive-search-input]'):focusable(target)[0])?.focus();
    }
    if(search){search.inert=true;searchOpener?.setAttribute('aria-expanded','false');}
    on(opener,'click',()=>{if(!desktop.matches)openModal(drawer,opener);});
    all('[data-sf-mobile-close]').forEach(el=>on(el,'click',()=>closeModal()));
    all('[data-sf-mobile-next]').forEach(el=>on(el,'click',()=>{mobileReturn=el;showPage(el.dataset.sfMobileNext);}));
    all('[data-sf-mobile-back]').forEach(el=>on(el,'click',()=>{showPage('main',false);mobileReturn?.focus();}));
    on(searchOpener,'click',()=>{if(desktop.matches)openModal(search,searchOpener);});
    all('[data-sf-header-search-close]').forEach(el=>on(el,'click',()=>closeModal()));
    on(document,'keydown',event=>{
      if(event.key==='Escape'){if(modal){event.preventDefault();closeModal();}else if(active!==null){event.preventDefault();closeMega(true);}return;}
      if(event.key==='Tab'&&modal){
        const list=focusable(modal);if(!list.length)return;
        if(!modal.contains(document.activeElement)){event.preventDefault();(event.shiftKey?list.at(-1):list[0]).focus();}
        else if(event.shiftKey&&document.activeElement===list[0]){event.preventDefault();list.at(-1).focus();}
        else if(!event.shiftKey&&document.activeElement===list.at(-1)){event.preventDefault();list[0].focus();}
      }
    });
    on(desktop,'change',()=>{closeMega();closeModal();});
    on(header,'shopify:block:select',event=>{
      const panel=event.target.closest('[data-sf-mega-panel]');
      const page=event.target.closest('[data-sf-mobile-page]');
      if(desktop.matches&&panel)openMega(panel.dataset.sfMegaPanel);
      else if(!desktop.matches&&page){openModal(drawer,opener);showPage(page.dataset.sfMobilePage);}
    });
    const syncHeight=()=>document.documentElement.style.setProperty('--sf-header-height',`${header.getBoundingClientRect().height}px`);
    const resize=new ResizeObserver(syncHeight);resize.observe(header);syncHeight();
    on(document,'cart:updated',async()=>{
      try{const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart.js`,{signal:lifecycle.signal});if(!response.ok)return;const cart=await response.json();find('[data-sf-cart-indicator]')?.classList.toggle('is-visible',cart.item_count>0);}catch(error){if(error.name!=='AbortError')console.warn('Cart indicator could not refresh.');}
    });
    on(find('[data-sf-cart-trigger]'),'click',()=>{closeMega();closeModal(false);if(window.CartDrawer){window.CartDrawer.init?.();window.CartDrawer.open?.();}else document.dispatchEvent(new CustomEvent('cart:open'));});
    closeMega();
    [drawer,search].forEach(el=>{if(el){el.classList.remove('is-open');el.setAttribute('aria-hidden','true');el.inert=true;}});
    showPage('main',false);
    instances.set(header,()=>{closeMega();closeModal(false);lifecycle.abort();resize.disconnect();document.documentElement.style.removeProperty('--sf-header-height');instances.delete(header);});
  }
  const init=()=>document.querySelectorAll('[data-sf-header]').forEach(mount);
  window.AZEditorialHeader={init};init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-sf-header]').forEach(h=>instances.get(h)?.()));
})();
